<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Shadow</span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="shadow-slider"
        v-model="shadow"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="shadowClasses"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { ShadowClasses } from '../classes/ShadowClasses'
  export default MenuStyleProperty.extend({
    computed: {
      shadowClasses() {
        return Object.keys(ShadowClasses)
      },
      shadow: {
        get() {
          let currentShadow = this.elementClasses(this.classes)[this.device].find(elementClass => this.shadowClasses.includes(elementClass.value))
          if (! currentShadow) {
            currentShadow = {property: 'Shadow', value: 'SHADOW_NONE', touched: false}
            this.addToArray(this.module, [currentShadow], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentShadow.value
        },
        set: _.debounce(function (value) {
          let currentShadow = this.elementClasses(this.classes)[this.device].find(elementClass => this.shadowClasses.includes(elementClass.value))
          value = {property: 'Shadow', value: value, touched: currentShadow.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
